export default __webpack_public_path__ + "static/artifakt-element-regular-222cee212373cea81a1ecdfc4b4db77f.ttf";